import { validateWithSchema } from "@/helpers/common";
import { formatString } from "@/helpers/formatting";
import {
  type EmailTypeResponse,
  EmailTypeResponseSchema,
  type UpdateEmailTypePayload,
} from "@/models/preferences";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { IUser } from "@/models/users";

class MyApiService {
  async getOrganizationUsers() {
    const response = await axiosClient.get<{ data: IUser[] }>(
      formatString(endpoints.MY.ORGANIZATION_USERS)
    );
    return response.data.data;
  }
  async savePreferences(payload: UpdateEmailTypePayload) {
    const response = await axiosClient.put<{ data: EmailTypeResponse }>(
      formatString(endpoints.MY.PREFERENCES),
      payload
    );
    return validateWithSchema(EmailTypeResponseSchema, response.data.data);
  }
}

const myApiService = new MyApiService();
export default myApiService;
